export const productLocale = (
  notary_product: { locale: string },
  key: string
) => `${notary_product.locale}.${key}`;

export const SHAREHOLDER_KEYS = ['p1', 'p2', 'p3', 'p4'];
